module.exports = __webpack_public_path__ + "img/quality.39a0b77f.svg";